import type { IProviderConfig } from '../types/template';

import {
  THUMB_ECOMPOSER,
  THUMB_FOXIFY,
  THUMB_GEMPAGES,
  THUMB_GEMX,
  THUMB_PAGE_FLY,
  THUMB_SHOPIFY,
  THUMB_SHOGUN,
} from './thumbnail';
import {
  GemXIcon,
  PageFlyIcon,
  FoxifyIcon,
  EComposerIcon,
  ShopifyIcon,
  GemPagesIcon,
  ShogunIcon,
} from '~/presentation/icons';
import { ProviderSource } from '../types/template';
import { GEMX_TEMPLATE_PREFIX } from './template';

export const PROVIDER_CONFIG: Record<ProviderSource, IProviderConfig> = {
  [ProviderSource.SHOPIFY_GEMX]: {
    label: 'GemX',
    prefix: `${GEMX_TEMPLATE_PREFIX}-`,
    thumbnail: THUMB_GEMX,
    isMapping: true,
    logo: { source: GemXIcon },
  },
  [ProviderSource.SHOPIFY_PAGE_FLY]: {
    label: 'PageFly',
    prefix: 'pf-',
    thumbnail: THUMB_PAGE_FLY,
    isMapping: true,
    pathName: 'apps/pagefly/pages',
    logo: { source: PageFlyIcon },
  },
  [ProviderSource.SHOPIFY_FOXIFY]: {
    label: 'Foxify',
    prefix: 'foxify-',
    thumbnail: THUMB_FOXIFY,
    isMapping: true,
    pathName: 'apps/foxify-builder/pages',
    logo: { source: FoxifyIcon },
  },
  [ProviderSource.SHOPIFY_ECOMPOSER]: {
    label: 'EComposer',
    prefix: 'ecom-',
    thumbnail: THUMB_ECOMPOSER,
    isMapping: true,
    pathName: 'apps/ecomposer/pages',
    logo: { source: EComposerIcon },
  },
  [ProviderSource.SHOPIFY_SHOGUN]: {
    label: 'Shogun',
    prefix: 'shogun',
    thumbnail: THUMB_SHOGUN,
    isMapping: true,
    logo: { source: ShogunIcon },
  },
  [ProviderSource.SHOPIFY]: {
    label: 'Shopify',
    thumbnail: THUMB_SHOPIFY,
    logo: { source: ShopifyIcon },
  },
  [ProviderSource.SHOPIFY_ORIGIN]: {
    label: 'Shopify',
    thumbnail: THUMB_SHOPIFY,
    logo: { source: ShopifyIcon },
  },
  [ProviderSource.SHOPIFY_GP_BACKUP]: {
    label: 'Shopify',
    thumbnail: THUMB_SHOPIFY,
    logo: { source: ShopifyIcon },
  },
  [ProviderSource.GEMPAGESV6]: {
    label: 'GemPages',
    thumbnail: THUMB_GEMPAGES,
    logo: { source: GemPagesIcon },
  },
  [ProviderSource.GEMPAGESV7]: {
    label: 'GemPages',
    thumbnail: THUMB_GEMPAGES,
    logo: { source: GemPagesIcon },
  },
};
